"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideInViewFrom = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ProductPreviewMainSlider_1 = require("./product-preview-main-slider/ProductPreviewMainSlider");
const ProductPreviewThumbSlider_1 = tslib_1.__importDefault(require("./product-preview-thumb-slider/ProductPreviewThumbSlider"));
const ProductPreviewLightBox_1 = require("./product-preview-light-box/ProductPreviewLightBox");
const cotopaxi_1 = require("@as/cotopaxi");
const useProductMedia_1 = require("../product-media/useProductMedia");
const common_utils_1 = require("@as-react/common-utils");
const react_redux_1 = require("react-redux");
const AnalyticsActions_creators_1 = require("../../../redux/analytics/actions/AnalyticsActions.creators");
const common_components_1 = require("@as-react/common-components");
const FilterUtil_1 = require("../../../util/FilterUtil");
const useABTest_1 = require("../../../hooks/useABTest");
const common_types_1 = require("@as-react/common-types");
const INITIAL_SLIDE_INDEX = 0;
const id = (0, common_utils_1.uniqueId)('', '', 4);
const carouselOffsetMap = new Map([
    [common_types_1.ABTestCookieValue.A, 1],
    [common_types_1.ABTestCookieValue.B, 1.2],
    [common_types_1.ABTestCookieValue.C, 1.3],
]);
var SlideInViewFrom;
(function (SlideInViewFrom) {
    SlideInViewFrom["CAROUSEL"] = "C";
    SlideInViewFrom["LIGHTBOX"] = "L";
})(SlideInViewFrom || (exports.SlideInViewFrom = SlideInViewFrom = {}));
const ProductPreview = ({ selectedColorId, productId, showImageTouchZoomHint, showLabels = true, onImageTouchZoom, }) => {
    const { mediaCollection, alt } = (0, useProductMedia_1.useProductMedia)();
    const { feature_toggles: { enable_pdp_andes, enable_pdp_carousel }, pageInfo: { isPDPPage }, } = (0, common_components_1.useAemConfig)();
    const { hasBCookie: pdpAndesCookie } = (0, useABTest_1.useABTest)(common_types_1.ABTestCookie.PDP_ANDES);
    const { getCookie: carouselCookie } = (0, useABTest_1.useABTest)(common_types_1.ABTestCookie.PDP_CAROUSEL);
    const isAndesEnabled = (0, FilterUtil_1.getABEnabledFeatureToggleValue)(enable_pdp_andes, Boolean(pdpAndesCookie));
    const [activeSlideIndex, setActiveSlideIndex] = (0, react_1.useState)(INITIAL_SLIDE_INDEX);
    const isCarouselABCookieEnabled = (0, FilterUtil_1.getABEnabledFeatureToggleValue)(enable_pdp_carousel, mediaCollection.length > 1 && isPDPPage && isAndesEnabled);
    const slidesPerView = carouselCookie ? carouselOffsetMap.get(carouselCookie) : 1;
    const [showABTestVariant, setShowABTestVariant] = (0, react_1.useState)(isCarouselABCookieEnabled);
    const popoverHandlers = (0, cotopaxi_1.usePopoverHandlers)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleUpdateSlideInView = (index, from) => {
        if (isNaN(index)) {
            return;
        }
        const uniqueImageId = `${id}_${productId}_${selectedColorId}_${index}${from}`;
        dispatch(AnalyticsActions_creators_1.analyticsActions.productDetailCarouselImageViewed(uniqueImageId));
    };
    const onActiveSlideIndexChange = (newActiveSlideIndex) => {
        setActiveSlideIndex(newActiveSlideIndex);
    };
    (0, react_1.useEffect)(() => {
        setActiveSlideIndex(INITIAL_SLIDE_INDEX);
        setShowABTestVariant(isCarouselABCookieEnabled);
    }, [selectedColorId, mediaCollection.length]);
    if (!mediaCollection)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductPreviewThumbSlider_1.default, { activeSlideIndex: activeSlideIndex, alt: alt, mediaCollection: mediaCollection, onActiveSlideIndexChange: onActiveSlideIndexChange }), showABTestVariant ? ((0, jsx_runtime_1.jsx)(ProductPreviewMainSlider_1.ProductPreviewMainSlider, { selectedColorId: selectedColorId, activeSlideIndex: activeSlideIndex, onActiveSlideIndexChange: onActiveSlideIndexChange, onUpdateSlideInView: isAndesEnabled ? handleUpdateSlideInView : undefined, showImageTouchZoomHint: showImageTouchZoomHint, showLabels: showLabels, onImageTouchZoom: onImageTouchZoom, popoverHandlers: popoverHandlers, slidesPerView: slidesPerView }, "ab-test-variant")) : ((0, jsx_runtime_1.jsx)(ProductPreviewMainSlider_1.ProductPreviewMainSlider, { selectedColorId: selectedColorId, activeSlideIndex: activeSlideIndex, onActiveSlideIndexChange: onActiveSlideIndexChange, showImageTouchZoomHint: showImageTouchZoomHint, showLabels: showLabels, onImageTouchZoom: onImageTouchZoom, popoverHandlers: popoverHandlers, slidesPerView: 1 }, "default")), (0, jsx_runtime_1.jsx)(ProductPreviewLightBox_1.ProductPreviewLightBox, { activeSlideIndex: activeSlideIndex, alt: alt, mediaCollection: mediaCollection, onActiveSlideIndexChange: onActiveSlideIndexChange, onUpdateSlideInView: showABTestVariant ? handleUpdateSlideInView : undefined, popoverHandlers: popoverHandlers })] }));
};
exports.default = ProductPreview;
